/**
 * Interface for the 'Policies' data
 */
export interface PoliciesEntity {
  id: string | number; // Primary ID
  name: string;
}
